import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Row, Col, Table, Button, Badge } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { addNotification } from 'actions/NotificationsActions';

import Breadcrumb from 'components/layout/Breadcrumb';
import Loader from 'components/layout/Loader';

import List from 'components/List';

import may from 'js/security';

import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';

class SepaAgreements extends React.Component {
  handleRowClick = id => {
    //this.setState({ showEdit: true, editedTeam })
  };

  getBreadcrumb = () => {
    const messages = this.props.intl.messages;
    return (
      <Breadcrumb
        crumbs={[
          { link: this.props.appIntl.urlPrefix + 'account', name: 'Dashboard' },
          { link: this.props.appIntl.urlPrefix + 'account/settings', name: messages.settings },
          { link: null, name: messages.sepa_mandates },
        ]}
        className="p-t-0"
      />
    );
  };

  render() {
    const { intl, list } = this.props;
    const messages = intl.messages;

    const columns = [messages.name, messages.type, messages.actions];
    let tBody = [];
    for (let i = 0; i < list.data.list.length; i++) {
      const { id } = list.data.list[i];

      tBody.push(
        <tr key={i} class="clickable" onClick={() => this.handleRowClick(id)}>
          <td class="v-align-middle text-right">
            <Button bsSize="sm" class="btn-rounded m-r-10">
              <i class="fa fa-pencil-alt" /> {messages.view}
            </Button>
          </td>
        </tr>
      );
    }

    const resultTable = list.pending ? (
      <Loader />
    ) : (
      <Table responsive hover>
        <thead>
          <tr>
            {columns.map((column, i) => {
              return (
                <th key={i} class={column == messages.actions ? 'text-right' : ''}>
                  {column}
                </th>
              );
            })}
          </tr>
        </thead>
        <ReactCSSTransitionGroup
          transitionName="tablerows"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={1}
          component="tbody"
        >
          {tBody}
        </ReactCSSTransitionGroup>
      </Table>
    );

    return (
      <DocMeta tags={generateMetaTags(messages.meta.teams)}>
        <List
          listName="sepaAgreements"
          url="/api/sepaagreements.json"
          list={this.props.list}
          title={messages.sepa_mandates}
          iconClass="fal fa-file-invoice"
          sortOptions={['cdate,desc']}
          breadcrumb={this.getBreadcrumb()}
        >
          {resultTable}
        </List>
      </DocMeta>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.sepaAgreements,
    user: state.login.user,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(SepaAgreements)
  )
);
